import React, { memo, useRef } from 'react';
import { mapColorNameToTheme } from '@/utils/helpers';
import {
  resolveColorName,
  resolveBool,
  resolveContentBlocks,
  resolveImageReference,
  resolveNumber,
  resolveRTC,
  resolveSpacingSize,
  resolveTabContent,
  resolveTheme,
} from '@/utils/resolvers';
import ComplexTabList from './ComplexTabList';
import CMSWrapper from '../shared/CMSWrapper';

const MappedComplexTabList = memo(
  ({ content, presentation, contentButtons, containerBackgroundImage }: any) => {
    const { tabColor } = presentation || {};
    const tabTheme = mapColorNameToTheme(tabColor);
    return (
      <div
        data-datalayer-position="complex_tab_list"
        data-datalayer-variant={presentation?.datalayerVariant}
      >
        <ComplexTabList
          content={content}
          {...presentation}
          tabTheme={tabTheme}
          contentButtons={contentButtons}
          containerBackgroundImage={containerBackgroundImage}
        />
      </div>
    );
  },
);

const ComplexTabListCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        tabGroupTitle: null,
        tabGroupDescription: [null, resolveRTC],
        tabContent: [null, resolveTabContent(resolveContentBlocks)],
      },
    ],
    imageDocument: ['containerBackgroundImage', resolveImageReference],
    componentParameterMap: [
      'presentation',
      {
        'carousel-template': 'template',
        'tab-color': ['tabColor', resolveColorName],
        'text-color': ['theme', resolveTheme('text-color')],
        'container-top-background-color': ['containerTopBackgroundColor', resolveColorName],
        'container-bottom-background-color': ['containerBottomBackgroundColor', resolveColorName],
        'top-spacing': ['containerTopSpacing', resolveSpacingSize],
        'bottom-spacing': ['containerBottomSpacing', resolveSpacingSize],
        'text-area-shadow': ['hasTextShadow', resolveBool],
        'background-overlay-opacity': ['backgroundOverlayOpacity', resolveNumber],
        'variant-label': 'datalayerVariant',
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedComplexTabList}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default ComplexTabListCMSWrapper;
